import React from 'react'
import PropType from 'prop-types'
import { responsiveFontSizes } from '@material-ui/core/styles'
import { PrintRoot } from './PrintView'
import Lib from '../loader'

function RootLayout({ children, theme }) {
  return (
    <Lib.ThemeProvider theme={responsiveFontSizes(theme)}>
      <PrintRoot>
        { children }
      </PrintRoot>
    </Lib.ThemeProvider>
  )
}

RootLayout.propTypes = {
  children: PropType.node.isRequired,
  theme: PropType.oneOfType([PropType.object, PropType.string]).isRequired,
}

export default RootLayout
